import { Component, Input, OnInit } from "@angular/core";
import { NgxSpinnerService } from "ngx-spinner";
import { LazyLoadEvent } from 'primeng/api';

import { GenericService } from "../service/API/generic.service";
import { IN_GeneralReq } from "../service/Interface/generic.interface";
import { UtilityService } from "./../../shared/utility.service";

@Component({
  selector: "app-generic-list",
  templateUrl: "./generic-visitor-list.component.html",
  styleUrls: ["./generic-visitor-list.component.scss"],
})
export class GenericVisitorListComponent implements OnInit {
  @Input() componentID;
  @Input() dynamic;
  selectedVisitor: any = {};
  searchByGeneral: IN_GeneralReq;
  searchResp: any;
  paginationCount: any;
  config: any;
  displayView: boolean = false;
  showDialog: boolean;
  page: any;
  size: any = 10;
  defaultPage: any;
  newVoterAdded: any;
  newData: any;
  timer: any;
  filterFlag: boolean = false;

  constructor(
    private genericService: GenericService,
    private utilityservice: UtilityService,
    private spinner: NgxSpinnerService,
  ) {
    this.searchByGeneral = {
      search: undefined,
      page: {
        number: 0,
        size: this.size,
      },
    };
  }

  getPageConfig() {
    this.genericService.getPageConfig().subscribe((res) => {
      this.config = res;
    });
  }
  handleEvent(event) {
    // if (event.name == "LAZY_LOAD") {
    //   this.page = this.utilityservice.PaginationPerPage(event.event);
    //   this.defaultPage.page.size = event.event.rows;
    // }
    if (this.newData != undefined) {
      this.selectedVisitor = this.newData.data;
      this.sendNewData(this.selectedVisitor);
    }
    if (event.name == "SELECT") {
      this.selectedVisitor = event.data;
      this.sendNewData(this.selectedVisitor);
      this.searchResp = [];
    }
  }
  sendNewData(data: any) {
    this.genericService.sendData(this.selectedVisitor, this.componentID);
    this.onClear();
  }
  editVoter(rowData) {
    this.selectedVisitor = rowData;
    this.displayView = true;
    this.showDialog = true;
  }

  addNewVoterEntry() {
    this.showDialog = true;
    this.displayView = false;
  }
  newAddedVoter(data: any) {
    this.newData = data;
    if (this.newData != undefined) {
      this.showDialog = false;
      this.displayView = false;
      this.handleEvent(this.newData.data);
    }
    this.onClear();
    this.searchResp = [];
  }
  onCancelEntry(data: any) {
    this.showDialog = data.isCancel;
  }

  onSearch() {
    this.filterFlag = true;
    clearTimeout(this.timer);
    this.spinner.show(); 
    this.timer = setTimeout(() => {
      this.spinner.hide();  
      this.genericService.getUserBySearch(this.searchByGeneral).subscribe(
        (resp: any) => {
          this.searchResp = resp.map(user => ({
            ...user,
            isExpired: this.isUserExpired(user.doe) // Check expiry
          }));
          this.paginationCount = this.searchResp.length;
        },
        (error) => {
          console.error("Error fetching users", error);
        }
      );
    }, 600);
  }
  
  // Function to check expiry
  isUserExpired(doe: string | null): boolean {
    if (!doe) return false; // No expiry date = active user
    const expiryDate = new Date(doe);
    const today = new Date();
    return expiryDate < today; // If expiry date is past, mark as expired
  }
  

  onClear() {
    this.searchByGeneral.search = null;
    this.filterFlag = false;
    this.searchResp = [];
   
  }

  ngOnInit() {
    this.getPageConfig();
  }
}
